export enum AlertsPipelineModeType {
  // New alerts pipeline is disabled
  DISABLED = 'disabled',
  // Both pipelines are enabled but new pipeline in shadow mode (alerts are processed but not shown)
  SHADOW = 'shadow',
  // New alerts pipeline is enabled (alerts are processed and shown)
  LIVE = 'live',
}

export enum AlertsPipelineConfigBooleanType {
  // Configuration is enabled/true
  TRUE = 'true',
  // Configuration is disabled/false
  FALSE = 'false',
}
